import { render, staticRenderFns } from "./MyInfoMenu.vue?vue&type=template&id=bbc0f094&scoped=true&"
import script from "./MyInfoMenu.vue?vue&type=script&lang=js&"
export * from "./MyInfoMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc0f094",
  null
  
)

export default component.exports